<template>
  <div class="menu_version--container" @click.stop="handleContainerClick" aria-hidden="true">
    {{ version }}
  </div>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-28 (1.0.0) (jhoward)
 *      - Add <menu-version> component to facilitate opening the options menu.
 *
 *    2025-04-08 (1.1.0) (jhoward)
 *      - Set aria-hidden="true" for the container element in <menu-version>.
 */

import {defineComponent} from 'vue'

export default defineComponent({
  name: "menu-version",
  props: {
    version: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      clickCount: 0,
      clickThreshold: 4,
      clickTimer: -1,
      clickTimeout: 5000
    };
  },
  methods: {
    handleContainerClick() {
      window.clearTimeout(this.clickTimer);
      this.clickCount++;
      if (this.clickCount >= this.clickThreshold) {
        this.$store.commit('openOptionsMenu');
        this.clickCount = 0;
      } else {
        window.setTimeout(() => {
          this.clickCount = 0;
        }, this.clickTimeout);
      }
    }
  }
})
</script>

<style scoped>
.menu_version--container {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size: 0.5em;
  padding-bottom: 52px;
}

.menu--section .menu_version--container {
  position: absolute;
  bottom: 1em;
  right: 1em;
  padding-bottom: 0;
}
</style>